export default {
  title: "Wir",
  sections: {
    about_us_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">SEU-Gruppe</div>Swiss Engineers United',
            text2: 'Die Plattform für Ingenieurinnen <br/> und Ingenieure in der Schweiz',
            image: '/seu/latest-assets/seu_24.jpg',
          }
        },
      }
    },
    about_us_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Wir'
          }
        }
      }
    },
    about_us_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_29.jpg',
          }
        }
      }
    },
    about_us_text_section: {
      fields: {
        field_one: {
          value: {
            text: 'Wir denken <br/> <div class="text-highlight">einen Schritt voraus </div>'
          }
        },
        field_two: {
          value: {
            text: 'SEU vernetzt: In unserer Gruppe finden Know-how, neueste Technologien und innovative Ideen unter einem Dach zusammen.'
          }
        },
        field_three: {
          value: {
            text: 'Wir bedienen den Schweizer Markt mit vereinter Schubkraft und höchsten Ansprüchen – und heben die Branche auf ein neues Level an Leistungsfähigkeit. Gemeinsam meistern wir die Herausforderungen der Engineering-Branche. Regional, national und international.'
          }
        },
      }
    },
    about_us_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Wir'
          }
        }
      }
    },
    about_us_text2_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Unternehmensstruktur <br></div> Unser Fundament  für<br/> Ihren Erfolg'
          }
        },
        field_two: {
          value: {
            text: 'Die Entwicklung der SEU-Gruppe und der Erfolg der einzelnen Partnerunternehmen ist langfristig ausgelegt und geht Hand in Hand. Als Co-Unternehmen profitieren Sie direkt vom Erfolg der gesamten Gruppe.'
          }
        },
        field_three: {
          value: {
            text: 'Mit unserem SEU-Geschäftsmodell bieten wir erfolgreichen Ingenieurunternehmen eine Partnerschaft auf Augenhöhe, die jede Einzelmarke stützt, stärkt und weiterbringt. Auch innovative Einzelkämpfer laden wir ein, ihr Potenzial innerhalb unseres Netzwerkes zu entfalten, bevor fehlende Fachkräfte oder andere Herausforderungen der Firma den Atem nehmen.'
          }
        },
      }
    },
    about_us_text3_section: {
      fields: {
        field_one: {
          value: {
            text: 'The <div class="text-highlight">SEU</div> company',
            text2: 'Visionary from the ground up'
          }
        },
        field_two: {
          value: {
            text: 'Swiss Engineers United AG is a holding company based in Pfäffikon SZ. We operate throughout Switzerland, as a consultant, service provider and producer. We have national and international production sites. The heart of SEU is currently the HMQ Group with 4 companies and over 125 employees.'
          }
        },
        field_three: {
          value: {
            text: 'The designers of Swiss Engineeres United are the right team for people with visions. We used to sit proudly on our self-made tree house platform and dream of big projects. Today, we design and develop living spaces, structures, and supply and transport networks for the whole of Switzerland - now as experienced engineers, strategists, business economists, and entrepreneurs'
          }
        },
      }
    },
    about_us_slider_section: {
      fields: {
        sections: {
          value: {
            section_one: 'Aktionariat',
            section_one_text: `
              Gründer/innen, private Investoren, Verkäufer/innen sowie Mitarbeitende aus den Partnerunternehmen verantworten die Finanzen der SEU und engagieren sich strategisch und operativ für die Weiterentwicklung der SEU. Verkäuferinnen und Verkäufer der Unternehmen haben die Möglichkeit, einen Teil ihres Verkaufserlöses in die SEU-Gruppe zu reinvestieren und als Co-Unternehmer/in an der Zukunftsentwicklung der Gruppe mitzuwirken.
            `,
            section_two_text: `
              SEU ist eine zentrale Plattform für Engineering Excellence. Sie ermöglicht Synergien und Skaleneffekte und einen aktiven Austausch. Sie umfasst die Geschäftsfelder <a href="/engineering" class="text-highlight">Bau, Geomatik und Planung</a> und individuellen <a href="/angebot" class="text-highlight">Support</a>.
            `,
            section_two: 'SEU-Holding',
            section_three: 'Partnerunternehmen',
            section_three_text: `Das tragfähige Fundament der SEU bilden die einzelnen Partnerunternehmen. Sie bleiben als Marke bestehen und behalten ihr Produktportfolio, ihre lokalen und regionalen Märkte sowie ihren Kundenstamm weiterhin bei.`
          }
        },
        shareholders: {
          value: {
            boxes: [{
              text: `
              Gründer und <br/> Mitarbeitende <br/> SEU-Gruppe`,
            }, {
              text: 'Private Investoren',
            }, {
              text: 'Verkäufer und <br/> Mitarbeitende <br/> Partnerunternehmen',
            }]
          }
        },
        partners: {
          value: {
            boxes: [{
              image: '/seu/hmq_gruppe.png'
            }, {
              text: 'Weitere <br />Partnerunternehmen'
            }, {
              text:  'Weitere <br />Partnerunternehmen'
            }, {
              text: `
                Hier könnte<br />
                Ihr<br />
                Unternehmen<br />
                stehen<br />
              `
            }]
          }
        },

      }
    },
    about_us_divider3_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Wir'
          }
        }
      }
    },
    about_us_team_section: {
      fields: {
        field_one: {
          value: {
            title: '<div class="text-highlight">VERWALTUNGSRAT</div> ',
            description: 'Die Swiss Engineers United AG ist eine Holding-Gesellschaft mit Sitz in Pfäffikon SZ',
            members: [
              {
                image: '/seu/members/seu_team_1.jpg',
                fullName: 'Franco Quinter',
                position: 'PRÄSIDENT',
                email: 'franco.quinter@seu.ch',
                phone: '+41 (0)79 682 47 47',
                website: 'quinter.ch',
                linkedin: 'https://linkedin.com/in/francoquinter',
                quote: '“Wir bringen innovative Kräfte der ganzen Schweiz zusammen und ziehen neue Fachkräfte an.“',
                boxes: [
                  {
                    experience: '  Dipl. Ingenieur ETH/SIA',
                  },
                  {
                    experience: 'Eidg. pat. Ingenieur-Geometer',
                  },
                  {
                    experience: 'Gründer und Mitglied des Verwaltungsrates HMQ-Gruppe',
                  },
                  {
                    experience: '25 Jahre Geschäftsführer und Projektleiter HMQ-Gruppe',
                  },
                  {
                    experience: 'Mehrfacher Unternehmer',
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen',
                  },
                  {
                    experience: 'Erfahrung in der Unternehmensentwicklung',
                  },
                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN'
              },
              {
                image: '/seu/members/seu_team_5.jpg',
                fullName: 'Patrick Kranz',
                position: 'VIZEPRÄSIDENT',
                email: 'patrick.kranz@seu.ch',
                phone: '+41 (0)78 780 29 27',
                website: 'axalo.com',
                // linkedin: 'https://www.linkedin.com/in/dr-patrick-kranz-7154061b6',
                slogan: 'afawfwa',
                quote: '“Best Practice hat bei uns einen hohen Stellenwert. Wir schätzen die individuellen Erfolgsrezepte der Unternehmen.“',
                boxes: [
                  {
                    experience: 'Dr. oec. HSG in Betriebswissenschaft, Universität St. Gallen (HSG)',
                  },
                  {
                    experience: 'Mehrfacher Unternehmer, u. a. im Ingenieur- und Vermessungsbereich',
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen',
                  },
                  {
                    experience: 'Erfahrung in der Unternehmensberatung (McKinsey & Company) und Private Equity (Fabrel Lotos)',
                  },
                  {
                    experience: 'Chartered Financial Analyst',
                  },
                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN'
              },
              {
                image: '/seu/members/seu_team_4.jpg',
                fullName: 'Christian Vetsch',
                position: 'MITGLIED',
                email: 'christian.vetsch@seu.ch',
                phone: '+41 (0)79 361 13 45',
                linkedin: 'https://linkedin.com/in/christianvetsch',
                slogan: 'afawfwa',
                experience: 'awaaaaaaaaaaaaaaaaaaaaa',
                quote: '“Erfolgreiche Nachfolgelösungen sind anspruchsvoll und existenziell. Wir sorgen für optimale Rahmenbedingungen.“',
                boxes: [
                  {
                    experience: 'Vermessungsingenieur, FHNW'
                  },
                  {
                    experience: 'Executive Master of Business Administration, FHGR'
                  },
                  {
                    experience: 'CAS in Corporate Finance and Mergers & Acquisitions, ZHAW Zürich'
                  },
                  {
                    experience: 'Gründer und Mitglied des Verwaltungsrates HMQ-Gruppe'
                  },
                  {
                    experience: '28 Jahre Geschäftsführer und Projektleiter HMQ-Gruppe'
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen'
                  },
                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN'
              },
              {
                image: '/seu/members/seu_team_2.jpg',
                fullName: 'Rogier Engelsma',
                position: 'MITGLIED',
                email: 'rogier.engelsma@seu.ch',
                phone: '+41 (0)76 335 99 81',
                linkedin: 'https://linkedin.com/in/rogierengelsma',
                slogan: 'afawfwa',
                experience: 'awaaaaaaaaaaaaaaaaaaaaa',
                boxes: [
                  {
                    experience: 'Lic. oec. in Betriebswissenschaft, Universität St. Gallen (HSG)'
                  },
                  {
                    experience: '17 Jahre Erfahrung im Direktinvestitionsgeschäft/Private Equity (Rivean Capital, Verium, Trilenium)'
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen'
                  },
                  {
                    experience: 'Erfahrung in der Unternehmensberatung (Arthur D. Little)'
                  },
                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN',
                quote: '“Wir bieten eine Antwort auf die aktuellen Herausforderungen der Branche: Partnerschaftliche Zusammenarbeit mit Vorwärtsstrategie statt Verdrängungswettbewerb.“'
              },
              {
                image: '/seu/members/seu_team_6.jpg',
                fullName: 'Marco Quinter',
                position: 'MITGLIED',
                email: 'marco.quinter@seu.ch',
                phone: '+41 (0)79 402 91 11',
                linkedin: 'https://linkedin.com/in/marcoquinter',
                slogan: 'afawfwa',
                boxes: [
                  {
                    experience: 'Lic. oec. publ. Universität Zürich',
                  },
                  {
                    experience: '20 Jahre Geschäftsleitung UPC Schweiz',
                  },
                  {
                    experience: 'Mehrfacher Unternehmer im IT-, Blockchain- und Telekombereich',
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen',
                  },
                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN',
                quote: '“Wir vereinen alle Kompetenzen, die es für ein gesundes und nachhaltiges Gruppenwachstum braucht.“'

              },
            ]
          }
        }
      }
    },
    about_us_divider4_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Wir'
          }
        }
      }
    },
    about_us_members_section: {
      fields: {
        field_one: {
          value: {
            title: '<div class="text-highlight">GESCHÄFTSLEITUNG</div>',
            description: 'Wir gestalten und entwickeln Lebensräume, Bauwerke sowie Versorgungs- und Verkehrsnetze für die gesamte Schweiz – und das als erfahrene Ingenieure, Planer und Unternehmer',
            members: [
              {
                image: '/seu/members/seu_team_4.jpg',
                fullName: 'Christian Vetsch',
                position: 'Co-Geschäftsführer',
                email: 'christian.vetsch@seu.ch',
                phone: '+41 (0)79 361 13 45',
                linkedin: 'https://linkedin.com/in/christianvetsch',
                quote: '“Erfolgreiche Nachfolgelösungen sind anspruchsvoll und existenziell. Wir sorgen für optimale Rahmenbedingungen.“',
                boxes: [
                  {
                    experience: 'Vermessungsingenieur, FHNW',
                  },
                  {
                    experience: 'Executive Master of Business Administration, FHGR',
                  },
                  {
                    experience: 'CAS in Corporate Finance and Mergers & Acquisitions, ZHAW Zürich',
                  },
                  {
                    experience: 'Gründer und Mitglied des Verwaltungsrates HMQ-Gruppe',
                  },
                  {
                    experience: '28 Jahre Geschäftsführer und Projektleiter HMQ-Gruppe',
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen',
                  },
                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN'
              },
              {
                image: '/seu/members/seu_team_1.jpg',
                fullName: 'Franco Quinter',
                position: 'Co-Geschäftsführer',
                email: 'franco.quinter@seu.ch',
                phone: '+41 (0)79 682 47 47',
                website: 'quinter.ch',
                linkedin: 'https://linkedin.com/in/francoquinter',
                quote: '“Wir bringen innovative Kräfte der ganzen Schweiz zusammen und ziehen neue Fachkräfte an.“',
                boxes: [
                  {
                    experience: 'Dipl. Ingenieur ETH/SIA',
                  },
                  {
                    experience: 'Eidg. pat. Ingenieur-Geometer',
                  },
                  {
                    experience: 'Gründer und Mitglied des Verwaltungsrates HMQ-Gruppe',
                  },
                  {
                    experience: '25 Jahre Geschäftsführer und Projektleiter HMQ-Gruppe',
                  },
                  {
                    experience: 'Mehrfacher Unternehmer',
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen',
                  },
                  {
                    experience: 'Erfahrung in der Unternehmensentwicklung',
                  },
                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN'
              },
              {
                image: '/seu/members/seu_team_3.jpg',
                fullName: 'Marek Franke',
                position: 'Leitung <br /> Business Development <br /> & Investitionen',
                email: 'marek.franke@seu.ch',
                phone: '+41 (0)79 458 20 32',
                linkedin: 'https://linkedin.com/in/marekfranke',
                quote: '“Unsere Gruppe ist mehr als die Summe ihrer erfolgreich geführten Gesellschaften. 1 + 1 > 2: Das ist die Erfolgsformel der SEU!“',
                boxes: [
                  {
                    experience: 'Lic. rer. pol. in Betriebswissenschaft, Universität Fribourg',
                  },
                  {
                    experience: '20 Jahre Erfahrung im Bereich von Unternehmensnachfolgen, Unternehmenskauf und -verkauf, M&A, Post Merger Integration',
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen',
                  },
                  {
                    experience: 'Gründer diverser Start-ups ',
                  },
                  {
                    experience: 'Investor in Impact Investment Projekte',
                  },
                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN',
                bio: `
               <ul> <li> Degree in business administration (lic. rer. pol.), University of Fribourg</li>
<li>20 years of experience in corporate succession, company purchase and sale, M&A, post-merger integration</li>
<li>Positions on various boards of directors</li>
<li>Founder of multiple start-ups </li>
<li>Investor in impact investment projects</li> </ul>
                `
              },
              {
                image: '/seu/members/seu_team_2.jpg',
                fullName: 'Rogier Engelsma',
                position: 'Leitung Finanzierung',
                email: 'rogier.engelsma@seu.ch',
                phone: '+41 (0)76 335 99 81',
                linkedin: 'https://linkedin.com/in/rogierengelsma',
                quote: '“Wir bieten eine Antwort auf die aktuellen Herausforderungen der Branche: Partnerschaftliche Zusammenarbeit mit Vorwärtsstrategie statt Verdrängungswettbewerb.“',
                boxes: [
                  {
                    experience: 'Lic. oec. in Betriebswissenschaft, Universität St. Gallen (HSG)',
                  },
                  {
                    experience: '17 Jahre Erfahrung im Direktinvestitionsgeschäft/Private Equity (Rivean Capital, Verium, Trilenium)',
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen',
                  },
                  {
                    experience: 'Erfahrung in der Unternehmensberatung (Arthur D. Little)',
                  },

                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN'
              },
              {
                image: '/seu/members/seu_team_6.jpg',
                fullName: 'Marco Quinter',
                position: 'Leitung Marketing <br/>& Kommunikation',
                email: 'marco.quinter@seu.ch',
                phone: '+41 (0)79 402 91 11',
                linkedin: 'http://www.linkedin.com/in/marcoquinter/',
                quote: '“Wir vereinen alle Kompetenzen, die es für ein gesundes und nachhaltiges Gruppenwachstum braucht.“',
                boxes: [
                  {
                    experience: 'Lic. oec. publ. Universität Zürich',
                  },
                  {
                    experience: '20 Jahre Geschäftsleitung UPC Schweiz',
                  },
                  {
                    experience: 'Mehrfacher Unternehmer im IT-, Blockchain- und Telekombereich',
                  },
                  {
                    experience: 'Diverse Verwaltungsratspositionen',
                  },
                ],
                buttonLabel: 'MEHR ERFAHREN',
                buttonLabelLess: 'SCHLIESSEN',
              }
            ]
          }
        }
      }
    }
  }
}
